import React, { createContext, useState, useContext } from 'react';

interface AddToCartData {
  drawerVisible: any;
  setDrawerVisible: any;
  successMsg: string;
  setSuccessMsg: any;
  error: boolean;
  setError: any;
  errorMsg: string;
  setErrorMsg: any;
  availabilityMessage: any;
  setAvailabilityMessage: any;
  sizeErrorMessage: string;
  setSizeErrorMessage: any;
  widthErrorMessage: string;
  setWidthErrorMessage: any;
  setItemUpdated: any;
  itemUpdated: boolean;
}

const AddToCartContext = createContext<AddToCartData>({
  drawerVisible: false,
  setDrawerVisible: () => {},
  successMsg: '',
  setSuccessMsg: () => {},
  error: false,
  setError: () => {},
  errorMsg: '',
  setErrorMsg: () => {},
  availabilityMessage: '',
  setAvailabilityMessage: () => {},
  sizeErrorMessage: '',
  setSizeErrorMessage: () => {},
  widthErrorMessage: '',
  setWidthErrorMessage: () => {},
  setItemUpdated: () => {},
  itemUpdated: false,
});

const AddToCartProvider = ({ children }: React.PropsWithChildren) => {
  const [drawerVisibleValue, setDrawerVisibleValue] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [error, setError] = useState<boolean>(false);
  const [sizeErrorMessage, setSizeErrorMessage] = useState<string>('');
  const [widthErrorMessage, setWidthErrorMessage] = useState<string>('');
  const [itemUpdated, setItemUpdated] = useState<boolean>(false);
  const [availabilityMessage, setAvailabilityMessage] = useState<string>('');

  return (
    <AddToCartContext.Provider
      value={{
        drawerVisible: drawerVisibleValue,
        setDrawerVisible: setDrawerVisibleValue,
        successMsg: successMsg,
        setSuccessMsg: setSuccessMsg,
        error: error,
        setError: setError,
        errorMsg: errorMsg,
        setErrorMsg: setErrorMsg,
        availabilityMessage: availabilityMessage,
        setAvailabilityMessage: setAvailabilityMessage,
        sizeErrorMessage: sizeErrorMessage,
        setSizeErrorMessage: setSizeErrorMessage,
        widthErrorMessage: widthErrorMessage,
        setWidthErrorMessage: setWidthErrorMessage,
        setItemUpdated: setItemUpdated,
        itemUpdated: itemUpdated,
      }}
    >
      {children}
    </AddToCartContext.Provider>
  );
};

export default AddToCartProvider;
export const useAddToCart = () => useContext(AddToCartContext);
